import {
    Box,
    Flex,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
    ToggleButton,
} from "@caspeco/casper-ui-library";
// eslint-disable-next-line caspeco-react/discourage-chakra-import
import { ScaleFade, VisuallyHidden } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { TimeSlot } from "types/time-slot";

interface WaitListTimeSlotProps {
    time: TimeSlot;
    onTimeClick: (time: TimeSlot) => void;
    selectedTimes: TimeSlot[];
    isWaitListModal?: boolean;
    disableAnimation?: boolean;
    trackingId?: string;
}

export default function WaitListTimeSlot({
    onTimeClick,
    time,
    selectedTimes,
    isWaitListModal,
    disableAnimation,
    trackingId,
}: WaitListTimeSlotProps) {
    const { t } = useTranslation();
    const isSelected = selectedTimes.some((selectedTime) => selectedTime.start.isSame(time.start));
    const timeString = time.start.format("HH:mm");
    const showWaitListLabel = !isWaitListModal;
    const timeSlot = (
        <ToggleButton
            key={timeString}
            onClick={() => onTimeClick(time)}
            isPressed={isSelected}
            w="full"
            size="lg"
            minW={0}
            px={ThemeSpaceVariable.Small}
            data-track-click={trackingId}
        >
            <Flex direction="column" align="center" gap="3px" lineHeight="1" minW={0} w="full">
                <Box>{timeString}</Box>
                {showWaitListLabel && (
                    <Text
                        as="span"
                        data-testid="waitlist-slot-label"
                        color={isSelected ? "inherit" : ThemeColorVariable.OnSurfaceSubdued}
                        display="block"
                        fontSize={ThemeFontSizeVariable.Small}
                        lineHeight="1"
                        maxW="full"
                        minW={0}
                        overflow="hidden"
                        textAlign="center"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        w="full"
                    >
                        {t("waitList.waitingList")}
                    </Text>
                )}
                {!showWaitListLabel && <VisuallyHidden>{t("waitList.waitingList")}</VisuallyHidden>}
            </Flex>
        </ToggleButton>
    );

    if (disableAnimation) {
        return timeSlot;
    }

    return (
        <Box minW={0} w="full">
            <ScaleFade
                initialScale={isWaitListModal ? 1 : 0.9}
                in={true}
                transition={{ enter: { duration: 0.5 } }}
            >
                {timeSlot}
            </ScaleFade>
        </Box>
    );
}
